// const apiKey = "c2e028e3-bfeb-401e-a4e1-f63e7d7ce43a";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

// Fetch all stories
const getStories = async () => {
  return axios.get(`${API_BASE_URL}/api/stories`);
};

// Fetch a single story
const getStory = async (storyId) => {
  return axios.get(`${API_BASE_URL}/api/stories/${storyId}`);
};

// Post a story
const postStory = async (payload) => {
  return axios.post(`${API_BASE_URL}/api/stories`, payload);
};

// Fetch all resources
const getResources = async () => {
  return axios.get(`${API_BASE_URL}/api/resources`);
};

// Fetch all therapists
const getTherapists = async () => {
  return axios.get(`${API_BASE_URL}/api/therapists`);
};

export { getStory, getStories, postStory, getResources, getTherapists };
export default API_BASE_URL;

// import axios from "axios";

// const baseUrl = "http://localhost:8080";

// //Fetch all stories data:
// const getStories = async () => {
//   return axios.get(`${baseUrl}/api/stories`);
// };
// //Fetch a single story data:
// const getStory = async (storyId) => {
//   return axios.get(`${baseUrl}/api/stories/${storyId}`);
// };

// //Post a single story:
// const postStory = async (payload) => {
//   return axios.post(`${baseUrl}/api/stories`, payload);
// };

// //Fetch all resources data:
// const getResources = async () => {
//   return axios.get(`${baseUrl}/api/resources`);
// };

// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

// export default API_BASE_URL;
// export { getStory, getStories, postStory, getResources };
